import ImdiConfiguration from '../orgs/imdi'
import NobelConfiguration from '../orgs/nobel'
import {OrgCustomizedConfiguration} from "../orgs/OrgCustomizedConfiguration";
import i18n from "i18next";
import {initReactI18next} from "react-i18next";
import {getSearchParamsLanguage} from "../../lib/locale-helpers";

/** Add new business organizations to the array below */
export const configurations: Record<string, OrgCustomizedConfiguration> = {
    [ImdiConfiguration.OrgIdentifier]: ImdiConfiguration,
    [NobelConfiguration.OrgIdentifier]: NobelConfiguration
}


const translations: Record<string, Record<string, Record<string, string>>> = {}

for (const org in configurations) {
    const ns = configurations[org].OrgIdentifier

    for (const lang in configurations[org].Translations) {
        if (!translations[lang]) translations[lang] = {}
        if (!translations[lang][ns]) translations[lang][ns] = {}

        for (const key in configurations[org].Translations[lang]) {
            translations[lang][ns][key] = configurations[org].Translations[lang][key]
        }
    }
}

i18n.use(initReactI18next).init({
    resources: translations,
    lng: getSearchParamsLanguage() || navigator.language.split('-')[0],
    fallbackLng: 'en',
    interpolation: {escapeValue: false},
}).then(() => initialLanguage = i18n.language)

export let initialLanguage = i18n.language

const _host = window.location.host.split(':')[0].toLowerCase()

export const defaultConfiguration: OrgCustomizedConfiguration = Object
    .values(configurations)
    .find(c => !!c.HostsConfiguration[_host]) || NobelConfiguration
